import styles from "./styles.module.css";

const PrivacyPolicy = () => {
  return (
    <div className={styles.container}>
      <h1>Politique de Confidentialité</h1>

      <p>
        Nous nous engageons à protéger la confidentialité des utilisateurs de
        notre plateforme. Cette politique de confidentialité explique quelles
        données sont collectées, pourquoi, et comment elles sont traitées.
      </p>

      <h2>Données personnelles collectées</h2>
      <p>
        Les seules données collectées sont celles strictement nécessaires à
        l’usage de notre plateforme, telles que :
      </p>
      <ul>
        <li>Adresse e-mail (lors de l’inscription)</li>
        <li>Nom d’utilisateur</li>
        <li>Préférences de langue</li>
      </ul>

      <h2>Utilisation des cookies</h2>
      <p>
        Notre site utilise <strong>uniquement des cookies techniques</strong>{" "}
        strictement nécessaires à son bon fonctionnement. Ces cookies ne
        nécessitent pas votre consentement, conformément à la réglementation
        (RGPD et recommandations de la CNIL).
      </p>

      <h3>Types de cookies utilisés :</h3>
      <ul>
        <li>
          <strong>Cookie de session</strong> : permet de maintenir votre
          connexion lors de votre navigation.
        </li>
        <li>
          <strong>Cookie de langue</strong> : enregistre la langue que vous avez
          choisie pour l'affichage du site.
        </li>
      </ul>

      <p>
        Ces cookies :
        <ul>
          <li>
            Ne collectent aucune information personnelle à des fins marketing
          </li>
          <li>Ne sont pas partagés avec des tiers</li>
          <li>
            Sont supprimés automatiquement à la fin de votre session ou après
            une durée limitée
          </li>
        </ul>
      </p>

      <h2>Vos droits</h2>
      <p>
        Conformément au Règlement Général sur la Protection des Données (RGPD),
        vous disposez des droits suivants :
      </p>
      <ul>
        <li>Droit d’accès à vos données</li>
        <li>Droit de rectification ou de suppression</li>
        <li>Droit de limitation ou d’opposition au traitement</li>
      </ul>

      <p>
        Pour exercer vos droits ou pour toute question, vous pouvez nous
        contacter à l’adresse suivante :{" "}
        <a href="mailto:contact@cardonize.com">contact@cardonize.com</a>
      </p>
    </div>
  );
};

export default PrivacyPolicy;
